import { notifications } from '@mantine/notifications'
import { useQueryClient } from '@tanstack/react-query'

import type { ManualAccountAddProps } from '@/components/ManualAccountAdd/ManualAccountAdd.types'
import { ManualAccountForm } from '@/components/ManualAccountForm/ManualAccountForm'
import type { ManualAccountFormSchema } from '@/components/ManualAccountForm/ManualAccountForm.types'
import { manualAccountFormDefaultValues } from '@/components/ManualAccountForm/ManualAccountForm.values'

import { INVALIDATE_KEYS } from '@/constants/invalidateAccountQueryKeys.constants'

import { useBankingServiceBankingControllerCreateManualAccount } from '@/__generated__/queries'

export function ManualAccountAdd({ onClose }: ManualAccountAddProps) {
  const queryClient = useQueryClient()

  const initialValues = manualAccountFormDefaultValues()

  const createManualAccountMutation =
    useBankingServiceBankingControllerCreateManualAccount({
      onSuccess: () => {
        notifications.show({
          color: 'green',
          message: 'Account created successfully',
          title: 'Account created',
        })

        INVALIDATE_KEYS.forEach(key => {
          queryClient.invalidateQueries({
            queryKey: [key],
          })
        })

        onClose()
      },
    })

  const handleSubmit = (values: ManualAccountFormSchema) =>
    createManualAccountMutation.mutate({
      requestBody: values,
    })

  return (
    <ManualAccountForm
      data={initialValues}
      onClose={onClose}
      onSubmit={handleSubmit}
    />
  )
}
